module.exports = __webpack_public_path__ + "static/media/Notification-HolidaySHipmentDelay-Email-Preview.be600cb4.png";